import { Middleware } from '@nuxt/types';
import { usePageStore, routeQuery } from '~/stores/page';

const urlResolverMiddleware : Middleware = async (context) => {
  const pageStore = usePageStore();
  const { path } = context.route;

  const clearUrl = path.replace(/[a-z]+\/[cp|]\//gi, '').replace(`/${context.i18n.locale}`, '');
  
  const { data, errors } = await context.app.$vsf.$magento.api.customQuery({
    query: routeQuery,
    customHeaders: {
        'Cache-Control': 'no-store, no-cache, must-revalidate',
        'Pragma': 'no-cache'
    },
    queryVariables: {
      url: clearUrl
    }
  });
  
  const results: any | null = (data as any)?.route ?? null;

  if (!results || errors?.length) context.error({ statusCode: 404 });

  try {
    if (results?.type === 'CATEGORY') {
      if (clearUrl.includes('temi-caldi.html')) {
        results.type = 'HOT_TOPICS';
      } else if (clearUrl.includes('/temi-caldi/')) {
        results.type = 'HOT_TOPIC';
      }
    }
  } catch (e) {
    console.warn('Error while checking hot topics path');
  }
    

  pageStore.$patch((state) => {
    state.routeData = results;
  });
};

export default urlResolverMiddleware;
